import { clsx } from 'clsx'
import React from 'react'

export interface LogoProps extends React.SVGProps<SVGSVGElement> {
  size?: 'sm' | 'md' | 'lg'
  variant?: 'default' | 'gradient'
}

const Logo = React.forwardRef<SVGSVGElement, LogoProps>(
  ({ size = 'md', variant = 'default', className, ...props }, ref) => {
    const sizeClasses = {
      sm: 'w-6 h-6',
      md: 'w-10 h-10',
      lg: 'w-16 h-16',
    }

    const logoClasses = clsx(sizeClasses[size], className)

    const fillClass =
      variant === 'gradient' ? 'url(#logo-gradient)' : 'currentColor'

    return (
      <svg
        ref={ref}
        className={logoClasses}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        {variant === 'gradient' && (
          <defs>
            <linearGradient
              id="logo-gradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" stopColor="var(--color-accent-cyan)" />
              <stop offset="50%" stopColor="var(--color-accent-purple)" />
              <stop offset="100%" stopColor="var(--color-accent-pink)" />
            </linearGradient>
          </defs>
        )}

        {/* Stack representation - layers building up */}
        <rect
          x="8"
          y="30"
          width="24"
          height="4"
          rx="2"
          fill={fillClass}
          opacity="0.8"
        />
        <rect
          x="6"
          y="24"
          width="28"
          height="4"
          rx="2"
          fill={fillClass}
          opacity="0.9"
        />
        <rect x="4" y="18" width="32" height="4" rx="2" fill={fillClass} />

        {/* Connection nodes */}
        <circle cx="12" cy="12" r="3" fill={fillClass} />
        <circle cx="28" cy="12" r="3" fill={fillClass} />
        <circle cx="20" cy="6" r="3" fill={fillClass} />

        {/* Connection lines */}
        <path
          d="M12 12 L20 6 L28 12"
          stroke={fillClass}
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
          opacity="0.6"
        />
      </svg>
    )
  }
)

Logo.displayName = 'Logo'

export default Logo
